import React from 'react';
import { compose } from 'ramda';

import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import validateAsyncComponent from '@synergycms_core/components/HoC/validateAsyncComponent';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import styleFile from './AvailMainSideSummaryServices.js';
import { RichText } from '@synergycms_core/components/generic';
import connect from 'react-redux/es/connect/connect';
import Price from '@synergycms_core/components/generic/Price';
import { withContent } from '@synergycms_core/components/providers/translateProvider';


const AvailMainSideSummaryServices = class AvailMainSideSummaryServices extends React.Component {
  static displayName = 'AvailMainSideSummaryServices';

  render() {
    const { config, theme, content } = this.props,
      {
        parsedServices,
        totalPriceServices,
        stepCode,
      } = config;

    const { classes } = theme.styles;
    
    return (
      <div className={[classes.contentModule, classes.extrasModule, classes.noBorderBottom].join(' ')}>
        <div className={classes.contentModuleRow}>
          <div className={[classes.contentModuleCell, classes.contentModuleCellTitle].join(' ')}>
            <RichText text={content.t('_%extras%_')} innerStyle={['roboto15BoldBlack', 'uppercase']} />
          </div>
          <div className={[classes.contentModuleCell, classes.contentModuleCellPrice].join(' ')}>
            <Price
              innerStyle={['summaryPriceSize15']}
              amount={totalPriceServices}
              forceHotelCurrency={stepCode === 'confirmation'}
            />
          </div>
        </div>

        {parsedServices && Object.values(parsedServices).map((service, key) => {
          if(service.has_closed_price !== undefined && service.has_closed_price !== true) return null;
          
          return (
            <div key={key} className={classes.contentModuleRow}>
              <div className={[classes.contentModuleCell, classes.contentModuleCellService, classes.large].join(' ')}>
                <div className={classes.serviceContainer}>
                  <RichText text={service.quantity + ' x '} />
                  <RichText text={service.serviceName} />
                </div>
                {service.stringDate && <RichText text={" " + service.stringDate} innerStyle={['roboto13Black', classes.serviceDayFormat]}/>}
              </div>
              <div className={[classes.contentModuleCell, classes.contentModuleCellPrice, classes.short].join(' ')}>
                <Price
                  innerStyle={['summaryPriceSmall', classes.priceNumbers]}
                  amount={service.servicePrice}
                  forceHotelCurrency={stepCode === 'confirmation'}
                />
              </div>
            </div>
          )
        })}
      </div>
    );
  }
};
const mapStateToProps = (store, ownProps) => {
  return {
    stepCode: store.getIn(['customer', 'step', 'current_step', 'code']),
  };
};

export default compose(
  validateAsyncComponent(mapStateToProps, ['fullVersion']),
  connect(
    mapStateToProps,
  ),
  PropertyManager([
    'parsedServices',
    'totalPriceServices',
    'stepCode',
  ]),
  withThemeJSS({ styleFile, link: true }),
  withContent('i18n')
)(AvailMainSideSummaryServices);
